var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-tracking",
    x: 0,
    y: 0.015,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-tracking1",
    serifid: "iconB-tracking"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.449,16.918c-0.022,-0.016 -0.064,-0.046 -0.064,-0.046c-0.996,-0.74 -1.908,-1.585 -2.739,-2.541c-1.881,-2.163 -2.858,-4.45 -2.858,-6.601c0.004,-3.424 2.77,-6.202 6.19,-6.224c0.011,-0 0.036,-0 0.036,-0c3.435,0.004 6.22,2.789 6.224,6.224c-0,2.15 -0.977,4.436 -2.856,6.598l-0.02,0.023c-0.813,0.935 -1.725,1.781 -2.767,2.553l-0.017,0.012c-0.159,0.113 -0.355,0.176 -0.565,0.176c-0.211,-0 -0.405,-0.066 -0.564,-0.174Zm0.564,-2.089c0.728,-0.604 1.996,-1.769 2.959,-3.27c0.718,-1.118 1.27,-2.426 1.27,-3.828c0,-2.336 -1.906,-4.23 -4.242,-4.23c-2.336,-0 -4.217,1.894 -4.217,4.23c0,1.402 0.552,2.71 1.27,3.828c0.963,1.501 2.231,2.666 2.96,3.27Zm-0.013,-9.314c1.242,0 2.25,1.008 2.25,2.25c0,1.242 -1.008,2.25 -2.25,2.25c-1.242,0 -2.25,-1.008 -2.25,-2.25c0,-1.242 1.008,-2.25 2.25,-2.25Zm-5.969,12.293l-2.006,2.675l15.95,-0l-2.006,-2.675l-1.113,0c-0.555,0 -1.012,-0.457 -1.012,-1.013c-0,-0.555 0.457,-1.012 1.012,-1.012l1.619,-0c0.319,-0 0.619,0.15 0.81,0.405l3.525,4.7c0.132,0.175 0.203,0.388 0.203,0.607c-0,0.556 -0.457,1.013 -1.013,1.013l-20,-0c-0.556,-0 -1.013,-0.457 -1.013,-1.013c0,-0.219 0.071,-0.432 0.203,-0.607l3.525,-4.7c0.191,-0.255 0.491,-0.405 0.81,-0.405l1.601,-0c0.556,-0 1.013,0.457 1.013,1.012c0,0.556 -0.457,1.013 -1.013,1.013l-1.095,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBTracking);
export default __webpack_public_path__ + "static/media/iconB-tracking.4e2c15a8121440205f7e749e95011cb4.svg";
export { ForwardRef as ReactComponent };